

















































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import _ from 'lodash';
import {
  DxDataGrid,
  DxColumn,
  DxLoadPanel,
  DxScrolling
} from 'devextreme-vue/data-grid';
import { MatterWorkMatterDto } from '@/models/matter-work/MatterWorkMatterDto';
import { FeeSheetsService } from '@/service/FeeSheetsService';
import { AgentFeeSheetTableDto } from '@/models/audit/AgentFeeSheetTableDto';
import { AgentFeeSheetTableColumnDto } from '@/models/audit/AgentFeeSheetTableDto';
import { AgentFeeSheetTableDetailEnum, AgentFeeSheetDetailColorEnum } from '@/models/audit/AgentFeeSheetTableDetailEnum';
import { FeeSheetDto } from '@/models/Fees/FeeSheetDto';
import { FeeSheetModalFor } from '@/models/Fees/FeeTypeEnum';
import { FeeSheetModalType } from '@/models/Fees/FeeTypeEnum';
import { AgentDto } from '@/models/agent/AgentDto';
import AddUpdateFeeSheets from '../fee-sheets/add-update-fee-sheets.vue';
import { ClientDto } from '@/models/client/ClientDto';
import { ManualCodeInvoiceLineItemDto } from '@/models/ManualCodeInvoiceLineItemDto';
@Component({
  components: {
      DxDataGrid,
      DxColumn,
      DxLoadPanel,
      DxScrolling,
      AddUpdateFeeSheets
  }
    
})
export default class AgentFeeSheetTable extends Vue {
  
  private agents: AgentDto[]  = [];
  private agentsFeeSheets: FeeSheetDto[] = [];
  
  @Prop()
  matter!: MatterWorkMatterDto;

  get matterId(): Guid {
    return this.matter.MatterId;
  }

  get matterLineItems() : ManualCodeInvoiceLineItemDto[] {
    return this.matter.LineItems;
  }

  @Watch("matter.MatterId")
  async onMatterChanged() {        
    await this.processGettingAgentFeeSheets();
  }

  feeSheetService: FeeSheetsService;
  feeSheetTableLoaded: boolean = false;

  clientFeeSheets: FeeSheetDto[] = [];

  private showAddUpdateFeeSheet: boolean = false;

  selectedFeeSheetId: Guid = "";
  feeSheetOwner: FeeSheetModalFor = FeeSheetModalFor.Agent;
  feeSheetUpdate: FeeSheetModalType = FeeSheetModalType.Update;

  get selectedFeeSheet(): FeeSheetDto{
    return _.clone(this.agentsFeeSheets.filter(s => s.FeeSheetId == this.selectedFeeSheetId)[0]);    
  }

  get client() : ClientDto| undefined {
    if(this.matter) {
      return {
        ClientId : this.matter.ClientId,
        ClientName : this.matter.ClientName
      }
    }
    else { return undefined;}
  }

  created() {
    this.loadData();
  }
  
  constructor() {
    super();
    this.feeSheetService = new FeeSheetsService('/api/FeeSheets');
  }

  async loadData() {    
    this.clientFeeSheets = (await this.feeSheetService.getFeeSheetPerClient(this.matter.ClientId));   
    await this.processGettingAgentFeeSheets();  
  }

  async processGettingAgentFeeSheets() {
    this.agents = _.uniqBy(this.matter.LineItems, item => item.AgentName)
                    .map(function(item): AgentDto {
                      return {AgentName: item.AgentName, AgentId: item.AgentId};
                    });
    let agentIds = this.agents.map(a => a.AgentId);
    this.agentsFeeSheets = await this.feeSheetService.getFeeSheetsStatus(this.matter.ClientId, agentIds);
  }

  feeSheetColumns: string[] = [];

  get columns() : string[] {    
    return this.feeSheetColumns;
  }
 
  get AgentFeeSheets() : AgentFeeSheetTableDto[] {    
    return this.processData(this.agentsFeeSheets);    
  }

  onContentReady(e: any) {
    if(!e.component.__firstLoad) {
      let items = e.component.getDataSource().items();

      if(items && items.length > 0) {
        this.feeSheetTableLoaded = true;
        e.component.__firstLoad = true;    
      }
    }    
  }

  widthValue = 250;
  heightValue = 120;

  processData(agentsFeeSheets: FeeSheetDto[]): AgentFeeSheetTableDto[] {
      let result: AgentFeeSheetTableDto[]= [];
      let agentsWithoutFeeSheets: AgentFeeSheetTableDto[] = [];
      let clientFeeSheetsFiltered = this.clientFeeSheets.filter(c => this.agentsFeeSheets.some(a => a.ParentFeeSheetId == c.FeeSheetId));    
      let clientFeeSheets = _.orderBy(clientFeeSheetsFiltered, c => c.FeeSheetName);
      this.feeSheetColumns = _.uniqBy(clientFeeSheets, c => c.FeeSheetName).map(s => s.FeeSheetName);
      this.feeSheetColumns = _.orderBy(this.feeSheetColumns, c => c.toLowerCase());

      //loop over agents in matter
      this.agents.forEach(agent => {
        let tableRow: AgentFeeSheetTableDto = {
          AgentName: agent.AgentName,
          Colors: [] as AgentFeeSheetDetailColorEnum[],
          FeeSheetIds: [] as Guid[]
        };  
        
        //then for each client fee sheet, make a column        
        clientFeeSheets.forEach(clientFeeSheet => {          
          let agentFeeSheet = this.agentsFeeSheets.find(s => s.ParentFeeSheetId == clientFeeSheet.FeeSheetId
            && s.AgentId == agent.AgentId);

          if(agentFeeSheet != undefined) {            
            tableRow.FeeSheetIds.push(agentFeeSheet.FeeSheetId);
            let tableColumn : AgentFeeSheetTableColumnDto = {
              Signed: agentFeeSheet.Signed,
              Modified: agentFeeSheet.Modified,
              EffectiveDate : (this.$options.filters as any).moment(agentFeeSheet.EffectiveDate,"MM-DD-YYYY"),
              LastSentDate : agentFeeSheet.LastSentDate ? 
              (this.$options.filters as any).moment(agentFeeSheet.LastSentDate,"MM-DD-YYYY"):undefined           
            };
            let modifiedString = agentFeeSheet.Modified ? "Modified" : "";

            if(agentFeeSheet.Signed === "Yes") {
              if(agentFeeSheet.EffectiveDate) {
                tableRow[agentFeeSheet.FeeSheetName] = `${AgentFeeSheetTableDetailEnum.Signed} ${modifiedString} ${new Date(agentFeeSheet.EffectiveDate).toDateString()}`; 
              }                  
              tableRow.Colors.push(AgentFeeSheetDetailColorEnum.Signed);
            }
            else if(agentFeeSheet.Signed !== "Yes" && agentFeeSheet.Signed !== "No"){
              let signedDetail = agentFeeSheet.Signed.replace(' of ','/');
              let detail = AgentFeeSheetTableDetailEnum.SignedXY.replace('X/Y', signedDetail);

              if(agentFeeSheet.EffectiveDate) {
                tableRow[agentFeeSheet.FeeSheetName] = `${detail} ${modifiedString} ${new Date(agentFeeSheet.EffectiveDate).toDateString() }`;  
              }              
              tableRow.Colors.push(AgentFeeSheetDetailColorEnum.SignedXY);
            }
            else if(agentFeeSheet.Signed === "No") {
              if(!agentFeeSheet.LastSentDate){
                tableRow[agentFeeSheet.FeeSheetName] = AgentFeeSheetTableDetailEnum.NotYetSent;
                tableRow.Colors.push(AgentFeeSheetDetailColorEnum.NotYetSent);
              }   
              else {
                tableRow[agentFeeSheet.FeeSheetName] = AgentFeeSheetTableDetailEnum.NotSigned;
                tableRow.Colors.push(AgentFeeSheetDetailColorEnum.NotSigned);
              }
            } 
          }      
          else {
            tableRow.FeeSheetIds.push("");
            tableRow.Colors.push(AgentFeeSheetDetailColorEnum.Blank);
          }    
        });

        if(tableRow.FeeSheetIds.every(id => id == "")) {
          agentsWithoutFeeSheets.push(tableRow);
        }
        else {
          result.push(tableRow);
        }        
      });
      
      result = _.orderBy(result, a => a.AgentName.toLowerCase());
      agentsWithoutFeeSheets = _.orderBy(agentsWithoutFeeSheets, a => a.AgentName.toLowerCase());
      result = result.concat(agentsWithoutFeeSheets);

      return result;
  }  

  onCellPrepared(e: any) {      
    if(e.rowType === 'data' && e.column.dataField !== "AgentName" && e.column.dataField != undefined) {
      let obj = e.row.data;        
      if(obj.hasOwnProperty(e.column.dataField)) { 
        e.cellElement.style['background-color'] = e.row.data.Colors[e.columnIndex-1];
      }
      else { 
        e.cellElement.style['background-color'] = AgentFeeSheetDetailColorEnum.Blank;
      }

      e.cellElement.style['width'] = this.widthValue;
    }
    else if(e.column.dataField == undefined) {
      e.cellElement.style['background-color'] = AgentFeeSheetDetailColorEnum.Blank;
    }
  }

  prepareContextMenu(e: any) {    
    if(e.target == "header" || e.columnIndex == 0 || e.column.dataField == undefined) {
      return;
    }    
    
    let feeSheetId = e.row.data.FeeSheetIds[e.columnIndex-1];
    if(feeSheetId != "") {
      e.items = [];
      e.items.push({
        text: "View Sheet",
        onItemClick: () => {
          this.openFeeSheet(feeSheetId);
        }
      });
    }
  }

  openFeeSheet(feeSheetId: Guid) {    
    this.selectedFeeSheetId = feeSheetId;
    this.showAddUpdateFeeSheet = true;
  }

  private saveFeeSheet(data: any): void {        
    this.showAddUpdateFeeSheet = false;
    this.selectedFeeSheetId = "";
    if(data && data.updateData) {
      this.processGettingAgentFeeSheets();
      this.$emit("feeSheetUpdated");
    }
  }

  private cancelFeeSheet(): void {
    this.selectedFeeSheetId = "";
    this.showAddUpdateFeeSheet = false;  
  }
}
